import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ClassAndEndpoint } from 'src/app/models/classandendpoint.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ServiceClass } from 'src/app/models/serviceClass.model';

@Component({
  selector: 'app-wagon-class-presentation',
  templateUrl: './wagon-class-presentation.component.html',
  styleUrls: ['./wagon-class-presentation.component.scss']
})
export class WagonClassPresentationComponent implements OnInit,OnDestroy {
  @Input() classes: BehaviorSubject<Array<Array<ClassAndEndpoint>>>;
  @Input() serviceClasses: ServiceClass[];

  private unscubscribe$ = new Subject<void>();
  classAreas:Array<Array<ClassAndEndpoint>> = new Array<Array<ClassAndEndpoint>>();
  single: boolean = false;
  multiple: boolean = false;
  classNumber: number;
  constructor() { }

  ngOnInit() {
    this.classes.pipe(takeUntil(this.unscubscribe$)).subscribe(value => {
      if (value) {
        this.classAreas = value;
        this.setSingleOrMultipleCheckState()
      }
      else {
        return;
      }
    });
  }

  setSingleOrMultipleCheckState() {
    if (this.classAreas.length == 1) {
      this.classNumber = this.classAreas[0].length == 1 ? 1 : 2;
    } else if (this.classAreas.length == 2) {
      this.classNumber = (this.classAreas[0].length == 1 && this.classAreas[1].length == 1) ? 1:2;
    }
  }
  ngOnDestroy(): void {
    this.unscubscribe$.next();
    this.unscubscribe$.complete();
  }
}
